import { useAdmin } from '@issuemanager/apps/client/hooks';
import { Navigate, Outlet } from 'react-router-dom';

interface Props {
  redirectPath: string;
}

export function AdminRoute({ redirectPath }: Props) {
  const isAdmin = useAdmin();

  if (!isAdmin) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
}
